export default __webpack_public_path__ + "static/media/mercedes.47791918.png";